import React, { useContext } from 'react';

import { RolesModuleContext } from '@vyce/core/src/contexts/rolesModuleProvider';
import { StaffPermissionsAccordion } from '@vyce/core/src/views/staff-management/StaffPermissionsAccordion';
import { removeStaffMemberRequest, updateStaffPermissionsRequest } from '@vyce/core/src/api/companies';

import { useTypedSelector } from 'src/hooks';
import { InvitesContext } from 'src/store/invites-context';

import { useModuleData } from './hooks';

export const StaffPermissionsModule: React.FC = () => {
  const { selectedCompany } = useTypedSelector(state => state.helper);
  const { createStaffInvite } = useContext(InvitesContext);
  const value = useModuleData();

  return (
    <RolesModuleContext.Provider value={value}>
      <StaffPermissionsAccordion
        selectedCompanyId={selectedCompany?.uuid || null}
        updateStaffPermissionsRequest={updateStaffPermissionsRequest}
        createStaffInviteRequest={createStaffInvite}
        removeStaffMemberRequest={removeStaffMemberRequest}
      />
    </RolesModuleContext.Provider>
  );
};
